import Polyglot from 'node-polyglot';
import { snakeToHumanCase, polyglotRegistry } from '@cyberint/common-utils';
import STRINGS from './resources';
import './trans'; // side-effect: registers the i18next 'integrations' bundle on load

const polyglot = new Polyglot({
  locale: polyglotRegistry.getLocale(),
  phrases: STRINGS
});

polyglotRegistry.register(polyglot, {
  en: STRINGS,
  loaders: {
    es: () => import(/* webpackChunkName: "integrations-locale-es" */ './locales/es'),
    fil: () => import(/* webpackChunkName: "integrations-locale-fil" */ './locales/fil'),
    ja: () => import(/* webpackChunkName: "integrations-locale-ja" */ './locales/ja'),
    th: () => import(/* webpackChunkName: "integrations-locale-th" */ './locales/th')
  }
});

export const integrationsTranslate = (key, params, defaultValue) =>
  polyglot.t(key, { ...params, _: defaultValue || snakeToHumanCase(key) });

export const t = integrationsTranslate;

export { integrationsT } from './trans';

export default integrationsTranslate;
